export default [
    { type: 'none', chartJsType: 'line', allowed: true, opts: { showLine: false, pointRadius: 4 } },
    { type: 'line', chartJsType: 'line', allowed: true, opts: { showLine: true, pointRadius: 3 } },
    { type: 'bubble', chartJsType: 'bubble', deprecated: true }, // no longer allowed, but retained to maintain backwards compatiblity with existing report templates
    { type: 'dotted line', chartJsType: 'line', allowed: true, opts: { showLine: true, pointRadius: 3 } },
];
